import React, { FC } from 'react';
import { Popover } from 'antd';
import moment from 'moment';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { ServiceCallPopoverDisplayV2 } from '../service_call_popover_display/ServiceCallPopoverDisplayV2';

const TIME_FORMAT = 'h:mm A';

// This is to render just enough big height of event to render text in it! Saw this in google calendar and implemented here
const GRID_HOUR_HEIGHT_PX = 90;
const CARD_ROW_HEIGHT_PX = 20;
const CARD_VERTICAL_PADDING_PX = 4;
const TWO_ROW_MINIMUM_PX = CARD_ROW_HEIGHT_PX * 2 + CARD_VERTICAL_PADDING_PX;

interface AppointmentCardProps {
	event: any;
}

export const AppointmentCard: FC<AppointmentCardProps> = ({ event }) => {
	if (!event) {
		return null;
	}

	const workOrderId = nullSafeGet('id', event);
	const title = nullSafeGet('title', event);
	const locationName = nullSafeGet('location.name', event);
	const displayEnd = nullSafeGet('displayEnd', event);
	const startMoment = moment(nullSafeGet('start', event));
	const startLabel = startMoment.format(TIME_FORMAT);
	const timeLabel = displayEnd
		? `${startLabel} - ${moment(displayEnd).format(TIME_FORMAT)}`
		: startLabel;

	const endMoment = moment(nullSafeGet('end', event));
	const renderedHeightPx =
		startMoment.isValid() && endMoment.isValid()
			? (endMoment.diff(startMoment, 'minutes') / 60) * GRID_HOUR_HEIGHT_PX
			: TWO_ROW_MINIMUM_PX;
	const showsMetaRow = renderedHeightPx >= TWO_ROW_MINIMUM_PX;

	return (
		<Popover
			trigger="click"
			placement="topLeft"
			overlayClassName="workOrderPopoverDisplay_wrapper"
			content={<ServiceCallPopoverDisplayV2 workOrder={event} />}
		>
			<div className="box-border flex h-full min-h-0 flex-col justify-start overflow-hidden px-2 py-0.5">
				<div
					className={`appointmentCard__title footnoteMedium min-h-0 text-grey-9${
						showsMetaRow ? '' : ' appointmentCard__title--singleLine'
					}`}
				>
					{workOrderId ? `#${workOrderId} ` : ''}
					{title}
				</div>
				{showsMetaRow ? (
					<div className="footnoteregular flex flex-none flex-row items-baseline gap-1 overflow-hidden text-character-secondary">
						{locationName ? (
							<span className="overflow-hidden text-ellipsis whitespace-nowrap">
								{locationName}
							</span>
						) : null}
						{locationName ? <span className="flex-none">&bull;</span> : null}
						<span className="flex-none whitespace-nowrap">{timeLabel}</span>
					</div>
				) : null}
			</div>
		</Popover>
	);
};
